module.exports = __webpack_public_path__ + "static/hamax-logo-6790fbf6cdb8a3ec6c788d428d9cc92c.png";